import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import WhoIWorkWith from '../components/WhoIWorkWith';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Blog from '../components/Blog';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import '../styles/Portfolio.css';

const Portfolio = () => {
  const location = useLocation();

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.reveal');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Scroll to hash target (e.g. #contact) when landing from another route
  useEffect(() => {
    if (!location.hash) return;
    const targetId = location.hash.replace('#', '');
    const HEADER_OFFSET = 96;
    let attempts = 0;
    let timer;

    const tryScroll = () => {
      const el = document.getElementById(targetId);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        timer = setTimeout(tryScroll, 100);
      }
    };

    tryScroll();
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="portfolio">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhoIWorkWith />
      <Skills />
      <Experience />
      <Blog />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;
